export default __webpack_public_path__ + "static/media/Husna.cc131a07.png";